"use client";

import React from "react";

//Types
import { CardProps } from "@/types";

//Styled
import * as S from "./styles";

const Card: React.FC<CardProps> = ({
  className,
  children,
  gap,
  heightFullScreen = false,
  heightFull = false,
  align = "center",
  justify,
}) => {
  return (
    <S.Card
      className={className}
      $gap={gap}
      $heightFullScreen={heightFullScreen}
      $heightFull={heightFull}
      $align={align}
      $justify={justify}
    >
      {children}
    </S.Card>
  );
};

export default Card;
